module.exports = __webpack_public_path__ + "img/users-solid.9d3553b2.svg";